import * as React from 'react';
import {InputNumber} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';

interface NumberFormItemProps extends BaseFormItemProps {
  min?: number;
  max?: number;
  parser?: (displayValue: string | undefined) => number | string;
  formatter?: (value: number | string | undefined) => string;
  onChange?: (value: number | undefined) => void;
  precision?: number;
  step?: number;
  hideIntegerDecimals?: boolean;
}


class NumberFormItem extends React.Component<NumberFormItemProps, {inputting: boolean}> {

  public readonly state = {inputting: false};

  public render(): React.ReactNode {
    const {disabled, min, max, parser, formatter, onChange, precision, step, hideIntegerDecimals} = this.props;
    return (
      <BaseFormItem
        {...this.props}
        input={
          <InputNumber
            className="mild-disabled"
            disabled={disabled}
            style={{width: 148}}
            min={min}
            max={max}
            precision={precision}
            step={step}
            onChange={onChange || hideIntegerDecimals ? this.fixedOnChange : undefined}
            onBlur={hideIntegerDecimals ? this.onBlur : undefined}
            formatter={hideIntegerDecimals ? this.formatNumber : formatter}
            parser={parser}
          />
        }
      />
    );
  }

  private formatNumber = (value: number | string | undefined): string => {
    const {formatter} = this.props;
    const displayValue = value === undefined ? '' : String(value);
    // Preserve partial decimals while typing, including the zero in "1,05".
    const formattedValue = this.state.inputting ? displayValue : displayValue
      .replace(/([.,]\d*?)0+$/, '$1')
      .replace(/[.,]$/, '');
    return formatter ? formatter(formattedValue) : formattedValue;
  };

  private onBlur = () => {
    this.setState({inputting: false});
  };

  private fixedOnChange = (value: number | undefined) => {
    if (this.props.hideIntegerDecimals) {
      this.setState({inputting: true});
    }
    const {onChange} = this.props;
    if (typeof value === 'number' || value === undefined) {
      if (onChange) {
        onChange(value);
      }
    } else {
      // Do nothing value is not number or undefined
      // It can happen when typing letters instead of numbers into the input
      // The validation will correct the value later, but the onChange callback
      // still got string values instead of numbers
    }
  };
}

export default NumberFormItem;



// WEBPACK FOOTER //
// ./src/common/form-items/NumberFormItem.tsx